/*!

 =========================================================
 * Vue Light Bootstrap Dashboard - v2.0.0 (Bootstrap 4)
 =========================================================

 * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import {EventBus} from "./eventbus";
import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";

// LightBootstrap plugin
import LightBootstrap from "./light-bootstrap-main";
import {BootstrapVue, IconsPlugin} from "bootstrap-vue";

// import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import "leaflet/dist/leaflet.css";

// router setup
import routes from "./routes/routes";

import "./registerServiceWorker";

// plugin setup
Vue.use(VueRouter);
Vue.use(LightBootstrap);
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
//import bootstrap css
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./assets/css/default.css";

// Vue.component('l-map', LMap);
// Vue.component('l-tile-layer', LTileLayer);
// Vue.component('l-marker', LMarker);

const limit = process.env.VUE_APP_IDLE_LIMIT || (60 * 60000);

Vue.prototype.$baseUrl = process.env.VUE_APP_BASE_URL;
Vue.prototype.$basePPN = 11;
Vue.prototype.$isMobile = screen.width < 768;


if (localStorage.getItem("lang") == null) {
	localStorage.setItem("lang", "id");
}


let counter = null;
let mspApp = null;
let timeIt = null;
let timeNotif = null;

// Vue.prototype.$baseUrl = 'http://127.0.0.1:8000'

//Support Moment JS
import moment from "moment";

moment.locale("id");
Vue.filter("timeformat", (value) => {
	return value != null ? moment(value).format("DD MMMM YYYY") : "-";
});
Vue.filter("timeformatTime", (value) => {
	return value != null ? moment(value).format("DD MMMM YYYY , h:mm") : "-";
});


//Support Numeral JS
import vueNumeralFilterInstaller from "vue-numeral-filter";

Vue.use(vueNumeralFilterInstaller, {locale: "en-gb"});

// configure router
const router = new VueRouter({
								 routes, // short for routes: routes
								 linkActiveClass: "nav-item active",
								 scrollBehavior: (to) => {
									 if (to.hash) {
										 return {selector: to.hash};
									 } else {
										 return {x: 0, y: 0};
									 }
								 }
							 });

Vue.prototype.$reActivateAccess = (app, timer = false) => {

	console.log("initiate access limit");

	app.$off("accesstimeout");
	app.$on("accesstimeout", () => {
		console.log("waktu akses anda telah habis !");
		localStorage.removeItem("accessToken");
		app.$router.push("/login");
	});

	//console.log('reset access token')
	if (counter != null) {
		clearTimeout(counter);
	}

	if (timer) {
		if (timeIt != null)
			clearInterval(timeIt);
		let second = 0;
		timeIt = setInterval(() => {
			second++;
			console.log("current second tick: " + second);
		}, 1000);
	}

	counter = setTimeout(function () {
		clearInterval(timeIt);
		app.$emit("accesstimeout");
	}, limit);

	timeNotif = setInterval(() => {
		app.$emit("notifHeader");
	}, 30000);

};

/* eslint-disable no-new */
mspApp = new Vue({
					 el: "#app",
					 render: h => h(App),
					 router
				 });

window.EventBus = EventBus;
//mspApp.$emit("accesstimeout")


